import { Mail, Phone } from 'lucide-react';
import Reveal from '../animations/Reveal';

const quickLinks = [
  { id: 'home', label: 'Home' },
  { id: 'analysis', label: 'Analysis' },
  { id: 'tools', label: 'Tools' },
  { id: 'howit-works', label: 'How It Works' },
  { id: 'about', label: 'About CryMiner' },
  { id: 'about-oneomics', label: 'About ONEOMICS' },
  { id: 'faqs', label: 'FAQs' },
  { id: 'feedback', label: 'Feedback' },
];

// Same protected ids as NavigationMenu.jsx / App.jsx's PROTECTED_TABS
const PROTECTED_LINK_IDS = ['analysis', 'tools'];

const Footer = ({ setActiveTab, isAuthenticated }) => {
  const visibleLinks = quickLinks.filter(
    (link) => isAuthenticated || !PROTECTED_LINK_IDS.includes(link.id)
  );

  return (
    <footer className="border-t border-slate-200 py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">

          {/* Quick Links */}
          <Reveal>
            <div>
              <h3 className="font-display text-lg font-semibold text-slate-900 mb-4">Quick Links</h3>
              <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                {visibleLinks.map((link) => (
                  <button
                    key={link.id}
                    onClick={() => setActiveTab(link.id)}
                    className="text-left text-slate-500 hover:text-brand hover:translate-x-1 transition-all text-sm"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>
          </Reveal>

          {/* Contact */}
          <Reveal delay={100}>
            <div>
              <h3 className="font-display text-lg font-semibold text-slate-900 mb-4">Contact</h3>
              <div className="space-y-2">
                <div className="flex items-center text-slate-500 hover:text-brand hover:translate-x-1 transition-all cursor-pointer">
                  <Mail className="w-4 h-4 mr-2 flex-shrink-0" />
                  <span>support@cryminer.in</span>
                </div>
                <div className="flex items-center text-slate-500 hover:text-brand hover:translate-x-1 transition-all cursor-pointer">
                  <Phone className="w-4 h-4 mr-2 flex-shrink-0" />
                  <span>+91 93605 50465</span>
                </div>
              </div>
            </div>
          </Reveal>

        </div>

        <div className="border-t border-slate-200 mt-8 pt-8 text-center text-slate-500">
          <p>&copy; 2026 CryMiner. All rights reserved. | Powered by ONEOMICS PRIVATE LIMITED</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;